<template>
    <v-dialog
        v-model="$props.params.addCategoryDialog"
        max-width="600px"
        transition="dialog-bottom-transition"
        @keydown.esc="closeAddCategoryDialog()"
        @click:outside="closeAddCategoryDialog()"
    >
        <v-card>
            <v-form @submit.prevent="processAddCategory()">

                <v-toolbar
                    :class="dialogHeadingClasses()"
                    color="primary"
                    dark
                >
                    <v-icon class="mr-3" v-text="icons.mdiAccountMultiplePlus"></v-icon>
                    <span class="text-truncate" v-text="textAddUserGroup"></span>
                    <v-spacer></v-spacer>
                    <v-icon class="mr-2" v-text="icons.mdiClose" @click.native.stop="closeAddCategoryDialog()"></v-icon>
                    <v-icon v-text="icons.mdiContentSave" @click.native.stop="processAddCategory()"></v-icon>
                </v-toolbar>

                <v-divider></v-divider>

                <v-card-text class="mt-8">
                    <v-container>
                        <v-row>
                            <v-col
                                cols="12"
                            >
                                <v-text-field
                                    v-model="categoryName"
                                    :error-messages="userGroupNameErrors"
                                    :label="$gettext('User Group Name')"
                                    :placeholder="$gettext('User Group Name')"
                                    autofocus
                                    clearable
                                    outlined
                                    required
                                    @blur="$v.categoryName.$touch()"
                                    @input="$v.categoryName.$touch()"
                                ></v-text-field>

                                <v-select
                                    v-model="internet"
                                    :error-messages="addInternetErrors"
                                    :items="getOptionsForUserGroupInternet()"
                                    :label="$gettext('Choose the Internet Option - Rules mode')"
                                    :placeholder="$gettext('Choose the Internet Option - Rules mode')"
                                    item-text="text"
                                    item-value="value"
                                    outlined
                                    required
                                    @blur="$v.internet.$touch()"
                                    @input="$v.internet.$touch()"
                                >
                                </v-select>

                                <v-select
                                    v-model="profile"
                                    :error-messages="addProfileErrors"
                                    :items="profiles"
                                    :label="$gettext('Categories Profile')"
                                    :placeholder="$gettext('Categories Profile')"
                                    item-text="profile_name"
                                    item-value="profile_name"
                                    outlined
                                    @blur="$v.profile.$touch()"
                                    @input="$v.profile.$touch()"
                                >
                                </v-select>

                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-divider></v-divider>

                <v-card-actions color="secondary">
                    <v-spacer></v-spacer>
                    <v-btn class="primary" v-text="$gettext('Close')"
                           @click.native.stop="closeAddCategoryDialog()"></v-btn>
                    <v-btn class="primary" type="submit" v-text="$gettext('Save')"></v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
</template>
<style type="text/scss">
.add-rule-radio-margin .v-input--selection-controls {
    margin-top: 0;
}
</style>

<script>

import {required} from 'vuelidate/lib/validators'

import MixinDialog from '@/mixins/MixinDialog'
import MixinIcon from '@/mixins/MixinIcon'
import Snackbar from '@/components/Snackbar'
import MixinStringManipulation from '@/mixins/MixinStringManipulation'
import MixinConfigUsers from '@/mixins/database/MixinConfigUsers'
import MixinVuelidate from '@/mixins/MixinVuelidate'
import {mapState} from 'pinia'
import {useCategoriesStore} from '@/stores/CategoriesStore'

export default {
    components: {Snackbar},
    mixins: [MixinDialog, MixinIcon, MixinStringManipulation, MixinConfigUsers, MixinVuelidate],
    props: {
        params: {
            required: true,
            type: Object,
        },
    },

    mounted() {

        let self = this;
        if (self.$props.params.internetProp) {
            self.internet = self.$props.params.internetProp;
        }

    },
    data() {
        return {
            categoryName: '',
            internet: '',
            profile: '',
        }
    },

    methods: {

        processAddCategory() {

            let self = this

            self.$v.$touch()

            if (!self.$v.$invalid) {

                self.$parent.addCategoryToDatabase({
                    key: self.categoryName,
                    value: [
                        {
                            'key': '@_internet',
                            'value': self.internet,
                        }, {
                            'key': '@_categories_profile',
                            'value': self.profile,
                        }
                    ]
                })

                self.$parent.$refs.snackbar.showSnackbar(self.$gettext('User group has been added successfully'))
                self.closeAddCategoryDialog()
                self.$parent.openAddUserUnderCategoryDialog(self.categoryName)

            }

        },

        closeAddCategoryDialog() {
            let self = this
            self.$parent.closeDialog('addCategoryDialog')
        },
        resetForm() {
            let self = this
            self.$v.$reset()
            self.categoryName = ''
            if (self.$props.params.internetProp) {
                self.internet = self.$props.params.internetProp;
            }
        },
    },
    computed: {

        userGroupNameErrors() {
            const errors = []
            if (!this.$v.categoryName.$dirty) return errors
            !this.$v.categoryName.required && errors.push(this.$gettext('User group name is required'))
            !this.$v.categoryName.isUnique && errors.push(this.$gettext('We already have a user group with this name'))
            return errors
        },

        addInternetErrors() {
            const errors = []
            if (!this.$v.internet.$dirty) return errors
            !this.$v.internet.required && errors.push(this.$gettext('Internet option is required'))
            return errors
        },

        addProfileErrors() {

            const errors = []
            if (!this.$v.profile.$dirty) return errors
            !this.$v.profile.required && errors.push(this.$gettext('Categories profile is required'));
            return errors

        },

        textAddUserGroup() {
            return this.$gettext('Add User Group')
        },

        ...mapState(useCategoriesStore,
            {profiles: 'profiles'}
        )

    },
    validations: {
        internet: {
            required,
        },
        categoryName: {
            required,
            async isUnique(value, vm) {
                return await this.vuelidateIsUniqueForKeyValueType(value, this.users)
            }

        },
        profile: {
            required,
        }
    }

}
</script>
